const blankToNull = require("./../../../utils").blankToNull;

export function validate(record) {
  const errors = [];
  if (!record.descricao) {
    errors.push({
      field: "descricao",
      message: "O campo descrição é obrigatório"
    });
  }
  if (!record.unidade) {
    errors.push({
      field: "descricao",
      message: "O campo unidade é obrigatório"
    });
  }
  if (!record.imagem) {
    errors.push({
      field: "descricao",
      message: "O campo imagem é obrigatório"
    });
  }
  blankToNull(record);
  const result = {
    ok: errors.length === 0,
    errors,
    record
  };
  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject;
    return action(result);
  });
}
